const getGroupColumnData = (visisbledColumns) => {
  // find any count/avg/min/max columns are visible
  let allGroupColumns = [],
    groupColumn = null,
    groupColumns = [], // Support multiple group columns
    groups = [],
    metricData = [];

  // Find all grouped columns (not just the first one)
  // Only columns marked as isGrouped, NOT metric columns (which have columnGroupKey but not isGrouped)
  groupColumns = visisbledColumns.filter((item) => item.isGrouped);

  // Keep groupColumn for backwards compatibility (first group)
  groupColumn = groupColumns.length > 0 ? groupColumns[0] : null;

  if (groupColumns.length > 0) {
    let metricColumns = visisbledColumns.filter((item) => item.aggregationType);

    allGroupColumns = [...groupColumns, ...metricColumns];

    metricData = metricColumns.map((item) => {
      return {
        columnKey: item.columnKey,
        aggregationType: item.aggregationType,
        aggregateColumn: item.aggregateColumn,
        columnGroupKey: item.columnGroupKey, // columnKey of group Column
      };
    });

    // Add all group columns to groups array
    groups = [
      ...groupColumns.map((gc) => ({
        columnKey: gc.columnKey,
        aggregateColumn: gc.aggregateColumn,
        bucketType: gc.bucketType,
        bucketConfig: gc.bucketConfig,
        columnGroupKey: gc.columnKey,
      })),
      ...metricData,
    ];
  }

  return {
    groupColumn, // the first groupColumn (for backwards compatibility)
    groupColumns, // all group columns
    metricData, // count/min/max/avg,..
    groups, // data store in backend
    allGroupColumns, // contain group column(s), and metric columns
  };
};
export { getGroupColumnData };
